import { NOT_AUTHORIZED_MESSAGE } from './not-authorized-message.js';
import { UNAVAILABLE_ACTION_MESSAGE } from './unavailable-action-message.js';

type ToolbarDisabledTooltipOptions = Readonly<{
  permitted: boolean;
  disabled?: boolean;
  disabledReason?: string;
  deniedMessage?: string;
}>;

export function toolbarDisabledTooltip({
  permitted,
  disabled,
  disabledReason,
  deniedMessage,
}: ToolbarDisabledTooltipOptions): string | undefined {
  if (!permitted) return deniedMessage ?? NOT_AUTHORIZED_MESSAGE;
  if (disabled) return disabledReason ?? UNAVAILABLE_ACTION_MESSAGE;
  return undefined;
}
